import { render } from "./Home_bk.vue?vue&type=template&id=43d1b128&scoped=true"
import script from "./Home_bk.vue?vue&type=script&lang=js"
export * from "./Home_bk.vue?vue&type=script&lang=js"

import "./Home_bk.vue?vue&type=style&index=0&id=43d1b128&scoped=true&lang=css"

import exportComponent from "/Volumes/WD 1/Development/Laravel/pessoalform_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d1b128"]])

export default __exports__